import React from 'react';

import useStyles from './styles';

const Grade = ({ grade, ownerGrade, handleClick, disabled = false }) => {
  const classes = useStyles({ ownerGrade });
  return (
    <div
      className={classes.container}
      onClick={disabled ? undefined : handleClick}
      style={disabled ? { cursor: 'not-allowed', opacity: 0.6, pointerEvents: 'none' } : {}}
    >
      <div className={classes.title}> {ownerGrade ? 'own grade' : 'grade'} </div>
      {grade === null ? (
        <div className={`${classes.body} ${classes.defaultBody}`}>
          <span>TBD</span>
        </div>
      ) : (
        <div className={classes.body}>
          <span>{grade}</span>
        </div>
      )}
      <div className={classes.textAfter} style={disabled ? { opacity: 0.5 } : {}}>
        View Scorecard
      </div>
    </div>
  );
};

export default Grade;
